import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { STATE_CULTURE, STATE_POS_ID } from "../../Actions/cookiesActions";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

let source;

const PaymentHeader = (props) => {
  const [text, setText] = useState("");
  const { config, posId, culture } = useSelector((state) => ({
    config: state.config,
    posId: state.cookies[STATE_POS_ID],
    culture: state.cookies[STATE_CULTURE],
  }));

  useEffect(() => {
    let CancelToken = axios.CancelToken;
    source = CancelToken.source();
    axios
      .get(
        `${config.baseUrl}/ee-static/checkout/pos-${posId}/Texts/paymentheader.${culture}.md`,
        {
          cancelToken: source.token,
        }
      )
      .then((r) => setText(r.data))
      .catch((e) => console.error(e));
  }, [culture, posId]);

  return (
    <ReactMarkdown
      className="paymentheader__text-container"
      rehypePlugins={[rehypeRaw]}
    >
      {text}
    </ReactMarkdown>
  );
};

export default PaymentHeader;
